<template>
    <section class="attendance-override">
        <div class="modal-header">
            <h3>Override Attendance</h3>
        </div>
        <app-form v-model="value" @submit.native.prevent="submit">
            <app-alert v-if="error" type="error">
                {{ error.message }}
            </app-alert>
            <app-form-item label="Status" prop="value.id">
                <app-select v-model="currentStatus" placeholder="Select">
                    <app-option
                        v-for="item in statuses"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"/>
                </app-select>
            </app-form-item>
            <div class="modal-footer">
                <app-button
                    :loading="isSaving"
                    type="primary"
                    size="large"
                    native-type="submit"
                    @click.prevent="submit">Save</app-button>
            </div>
        </app-form>
    </section>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { first } from '@/utilities'

export default {
    name: 'attendance-override',
    components: {},
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    inject: ['modalOptions'],
    data() {
        return {
            isSaving: false,
            error: null,
            currentStatus: this.value.status,
        }
    },
    computed: {
        ...mapState({
            statuses: ({ params }) => params.statuses
        })
    },
    mounted() {
        this.getParams()
    },
    methods: {
        ...mapActions(['getParams']),
        submit() {
            this.isSaving = true
            this.value.lock = 1
            this.value.overrides = [{ old_status: this.currentStatus }]
            this.value.status = this.currentStatus

            this.value.$update()
                .then(() => {
                    this.isSaving = false
                    this.modalOptions.modalOpen = false
                })
                .catch(error => {
                    this.error = first(error)
                    this.isSaving = false
                })
            return false
        }
    }
}
</script>

<style lang="stylus"></style>
